import type { AppScope } from './appScope.types';

export function workspaceSlugFromSettingsPath(
  pathname: string
): string | undefined {
  const match = pathname.match(/\/settings\/w\/([^/]+)/);
  return match?.[1];
}

export function teamSlugFromSettingsPath(pathname: string): string | undefined {
  const match = pathname.match(/\/settings\/w\/[^/]+\/teams\/([^/]+)/);
  return match?.[1];
}

export function resolveSettingsAppScopeFromPathname(
  pathname: string,
  organizationId: string
): AppScope | null {
  const workspaceSlug = workspaceSlugFromSettingsPath(pathname);
  if (!workspaceSlug) {
    return null;
  }

  const teamSlug = teamSlugFromSettingsPath(pathname);
  if (teamSlug) {
    return { level: 'team', organizationId, workspaceSlug, teamSlug };
  }

  return { level: 'workspace', organizationId, workspaceSlug };
}
